import axios from '../axios';

/**
 * 查询江西区划
 * @param {*} data 
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059386  20220422
 */
export const treeJxArea = data => {
  return axios({
    url: '/district/list',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/resource.js